export enum DIRECT_SETTLE {
  YES = 'Y',
  NO = 'N',
}

export enum ORDER_STATUS {
  OPEN_ORDER = 1,
  CANCELLED,
  MATCHED,
  SELF_MATCHED,
}

export enum STREAMS {
  QUOTE = 1,
  LAST_PRICE = 2,
  DEPTH = 3,
  LAST_CANDLESTICK = 4,
  ORDERS = 5,
  TRADES = 6,
  SYSTEM = 7,
  WALLET_TRANSACTIONS = 8,
  ALL_STAT = 9,
  CODEX_ASSETS = 12,
  CODEX_BALANCES = 10,
  LAST_LOOK = 11,
  SETTINGS_UPDATE = 13,
  NEW_NOTIFICATION = 14,
  POINT_SYSTEM_SETTINGS_UPDATE = 15,
}

export const PRIVATE_STREAMS = [
  STREAMS.ORDERS,
  STREAMS.WALLET_TRANSACTIONS,
  STREAMS.CODEX_BALANCES,
  STREAMS.LAST_LOOK,
];

export enum SOCIAL_ACTION_SOURCE {
  COMPANY = 'COMPANY',
  TWITTER = 'TWITTER',
  DISCORD = 'DISCORD',
  TELEGRAM = 'TELEGRAM',
}
